/* ====================================================================
   GENERAL PRODUCT V2
   - Variant selection (updates price, image, hidden variant id)
   - Qty stepper
   - Inline added-to-cart confirmation
   ==================================================================== */

(function () {
  'use strict';

  function formatMoney(cents, symbol) {
    var s = symbol || '$';
    var num = Math.round(cents) / 100;
    var amount = num % 1 === 0 ? num.toString() : num.toFixed(2);
    return s + amount;
  }

  function initSection(section) {
    if (section.dataset.gpInit === '1') return;
    section.dataset.gpInit = '1';

    var currency = section.dataset.gpCurrency || '$';
    var state = {
      unitCents: parseInt(section.dataset.gpBasePrice || '0', 10),
      qty: 1,
      options: []
    };

    var variantsScript = section.querySelector('[data-gp-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

    var priceEl = section.querySelector('[data-gp-price]');
    var ctaTotalEl = section.querySelector('[data-gp-cta-total]');
    var hiddenVariantInput = section.querySelector('[data-gp-hidden-variant-id]');
    var qtyInput = section.querySelector('[data-gp-qty]');
    var qtyDisplay = section.querySelector('[data-gp-qty-display]');
    var mainCta = section.querySelector('[data-gp-main-cta]');
    var heroImg = section.querySelector('[data-gp-hero]');
    var addedEl = section.querySelector('[data-gp-added]');
    var addedTextEl = section.querySelector('[data-gp-added-text]');
    var afterpayEl = section.querySelector('[data-gp-afterpay]');

    // Collect option values on load
    var optionInputs = section.querySelectorAll('.gp-option__input:checked');
    optionInputs.forEach(function (inp) {
      var idx = parseInt(inp.getAttribute('data-gp-option-index'), 10);
      state.options[idx] = inp.value;
    });

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < state.options.length; j++) {
          if (v.options[j] !== state.options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render() {
      var variant = findVariant();
      if (!variant) return;

      state.unitCents = variant.price;
      var total = state.unitCents * state.qty;

      if (priceEl) priceEl.textContent = formatMoney(variant.price, currency);
      if (ctaTotalEl) ctaTotalEl.textContent = formatMoney(total, currency);
      if (afterpayEl) afterpayEl.textContent = formatMoney(Math.round(variant.price / 4), currency);
      if (hiddenVariantInput) hiddenVariantInput.value = variant.id;
      if (qtyInput) qtyInput.value = state.qty;
      if (qtyDisplay) {
        if (qtyDisplay.tagName === 'INPUT') qtyDisplay.value = state.qty;
        else qtyDisplay.textContent = state.qty;
      }

      // CTA disabled if unavailable
      if (mainCta) {
        if (variant.available) {
          mainCta.disabled = false;
          mainCta.classList.remove('is-sold-out');
        } else {
          mainCta.disabled = true;
          mainCta.classList.add('is-sold-out');
        }
      }

      // Disable chips for invalid combinations per option
      disableInvalidChips();

      // Swap hero image if variant has one
      if (heroImg && variant.featured_image) {
        var url = variant.featured_image.src;
        if (url) heroImg.src = url;
      }

      // Update displayed selected value text
      var valueLabels = section.querySelectorAll('[data-gp-option-value]');
      valueLabels.forEach(function (lbl) {
        var idx = parseInt(lbl.getAttribute('data-gp-option-value'), 10);
        if (state.options[idx]) lbl.textContent = state.options[idx];
      });
    }

    function disableInvalidChips() {
      // For each option, disable chips that produce no available combination with other selected options
      var optionGroups = section.querySelectorAll('.gp-option');
      optionGroups.forEach(function (group, groupIdx) {
        var inputs = group.querySelectorAll('.gp-option__input');
        inputs.forEach(function (inp) {
          var testOptions = state.options.slice();
          testOptions[groupIdx] = inp.value;
          var found = false;
          for (var k = 0; k < variants.length; k++) {
            var match = true;
            for (var o = 0; o < testOptions.length; o++) {
              if (variants[k].options[o] !== testOptions[o]) { match = false; break; }
            }
            if (match && variants[k].available) { found = true; break; }
          }
          inp.disabled = !found;
        });
      });
    }

    // Option change
    section.querySelectorAll('.gp-option__input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var idx = parseInt(inp.getAttribute('data-gp-option-index'), 10);
        state.options[idx] = inp.value;
        render();
      });
    });

    // Qty stepper
    var minusBtn = section.querySelector('[data-gp-qty-minus]');
    var plusBtn = section.querySelector('[data-gp-qty-plus]');
    function changeQty(delta) {
      var n = state.qty + delta;
      if (n < 1) n = 1;
      if (n > 20) n = 20;
      state.qty = n;
      render();
    }
    if (minusBtn) minusBtn.addEventListener('click', function () { changeQty(-1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { changeQty(1); });

    if (qtyDisplay && qtyDisplay.tagName === 'INPUT') {
      qtyDisplay.addEventListener('input', function () {
        qtyDisplay.value = qtyDisplay.value.replace(/[^0-9]/g, '');
      });
      qtyDisplay.addEventListener('change', function () {
        var n = parseInt(qtyDisplay.value, 10);
        if (isNaN(n) || n < 1) n = 1;
        if (n > 20) n = 20;
        state.qty = n;
        render();
      });
      qtyDisplay.addEventListener('blur', function () {
        if (!qtyDisplay.value || qtyDisplay.value === '0') {
          state.qty = 1;
          render();
        }
      });
    }

    // Added-to-cart inline confirmation
    var productFormEl = section.querySelector('[data-js-product-form]');
    var addedTimeout = null;
    if (productFormEl) {
      productFormEl.addEventListener('add-to-cart', function () {
        if (!addedEl || !addedTextEl) return;
        var variant = findVariant();
        var title = variant ? (variant.title === 'Default Title' ? 'Added' : variant.title) : 'Added';
        addedTextEl.textContent = title + (state.qty > 1 ? ' × ' + state.qty : '') + ' added!';
        addedEl.hidden = false;
        addedEl.classList.remove('qlv2-added--fade');
        if (addedTimeout) clearTimeout(addedTimeout);
        addedTimeout = setTimeout(function () {
          addedEl.classList.add('qlv2-added--fade');
          setTimeout(function () { addedEl.hidden = true; }, 300);
        }, 3000);

        state.qty = 1;
        render();
      });
    }

    // Gallery dot pagination
    var gallery = section.querySelector('.ql-gallery');
    var dots = section.querySelectorAll('.ql-gallery__dot');
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var index = Math.round(gallery.scrollLeft / gallery.offsetWidth);
        dots.forEach(function (dot, i) {
          dot.classList.toggle('ql-gallery__dot--active', i === index);
        });
      }, { passive: true });
    }

    render();
  }

  function init(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-gp-section]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
